import { RootState } from 'store/types';
import { createSelector } from 'reselect';

export const languagesStateSelector = (state: RootState) => state.providerSearch.languages;

export const languagesDataSelector = createSelector(languagesStateSelector, s => s.data);
